import { Draft, isDraft } from 'immer'

export const isImmerDraft = isDraft as <T>(value: T | Draft<T>) => value is Draft<T>
